import ArrowLeftCarousel from "~/assets/icons/ArrowLeftCarousel";
import { carouselHome } from "../../../setup/settings/index";
import Carousel from "framer-motion-carousel";
import { cloneElement } from "react";

export function CarouselHome({ control, content }: { control?: JSX.Element, content?: JSX.Element }) {
    const images = carouselHome.items;

    return (
        <section className='CarouselHome'>
            <div className="CarouselHome__container">
                <div id="CarouselHome" className="carousel slide" data-ride="carousel">
                    <Carousel
                        renderDots={({ activeIndex, setActiveIndex }) =>
                            <ol className="carousel-indicators">
                                {images.map((_, i) => <li onClick={() => setActiveIndex(i)} data-target="#CarouselHome" data-slide-to={i} className={`${activeIndex == i && "active"}`}></li>)}
                            </ol>
                        }
                        renderArrowLeft={({ handlePrev }) =>
                            <div className="carousel-control" data-slide="prev" onClick={handlePrev}>
                                {control ? control : <div className="default"><ArrowLeftCarousel /></div>}
                            </div>
                        }
                        renderArrowRight={({ handleNext }) =>
                            <div className="carousel-control right" data-slide="next" onClick={handleNext}>
                                {control ? control : <div className="default"><ArrowLeftCarousel /></div>}
                            </div>
                        }
                        interval={carouselHome.interval}
                    >

                        {images.map((item, i) => (
                            <div className="carousel-inner">
                                <div className="item active">
                                    {images[i].redirectImage ?
                                        <a href={images[i].url}>
                                            <img
                                                className="CarouselHome__img--desktop"
                                                draggable="false"
                                                src={item.src}
                                                key={i}
                                                width="100%"
                                                alt=""
                                            />
                                            {content ? cloneElement(content, { image: images[i] }) :
                                                <div className="carousel-caption">
                                                    <h2>{images[i].h2}</h2>
                                                    {images[i].logo != undefined && images[i].logo != null && images[i].logo != "" &&
                                                        <img className={"carousel-logo"} src={images[i].logo}></img>
                                                    }
                                                    <p>{images[i].p}</p>
                                                    {images[i].showButton &&
                                                        <a href={`${images[i].url}`} className="btn-carousel">{images[i].a}</a>
                                                    }
                                                </div>
                                            }

                                        </a> :
                                        <>
                                            <img
                                                className="CarouselHome__img--desktop"
                                                draggable="false"
                                                src={item.src}
                                                key={i}
                                                width="100%"
                                                alt=""
                                            />
                                            {content ? cloneElement(content, { image: images[i] }) :
                                                <div className="carousel-caption">
                                                    <h2>{images[i].h2}</h2>
                                                    {images[i].logo != undefined && images[i].logo != null && images[i].logo != "" &&
                                                        <img className={"carousel-logo"} src={images[i].logo}></img>
                                                    }
                                                    <p>{images[i].p}</p>
                                                    {images[i].showButton &&
                                                        <a href={`${images[i].url}`} className="btn-carousel">{images[i].a}</a>
                                                    }
                                                </div>
                                            }
                                        </>
                                    }

                                </div>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </div>
        </section >
    )
}